import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'

@Component({
    selector: 'app-column-control-simple',
    templateUrl: './column-control-simple.component.html',
    styleUrls: ['./column-control-simple.component.scss'],
    standalone: false
})
export class ColumnControlSimpleComponent extends ColumnControlBaseComponent {}
